export async function acquireRecordingWakeLock({
  native,
  nativePlugin,
  wakeLockApi = globalThis.navigator?.wakeLock
}) {
  if (native) {
    if (!nativePlugin?.keepAwake) throw new Error('Native KeepAwake plugin is unavailable');
    await nativePlugin.keepAwake();
    return { kind: 'native' };
  }

  if (!wakeLockApi?.request) return null;
  try {
    const handle = await wakeLockApi.request('screen');
    return handle ? { kind: 'web', handle } : null;
  } catch (_) {
    return null;
  }
}

export async function releaseRecordingWakeLock({ lock, nativePlugin }) {
  if (!lock) return;
  if (lock.kind === 'native') {
    if (nativePlugin?.allowSleep) await nativePlugin.allowSleep();
    return;
  }
  if (lock.kind === 'web' && lock.handle?.release) {
    await lock.handle.release();
  }
}
